import { TSegment } from '@/features/segments/types';

import { TBroadcastScheduleProgramBodySegmentToolkitAdvertisementItem } from '../../types';

export function getSegmentAssignations(segment: TSegment) {
  const uniqueMap = new Map<string, TBroadcastScheduleProgramBodySegmentToolkitAdvertisementItem>();

  for (const segmentMention of segment.segment_mentions) {
    for (const workspaceId of segmentMention.workspaces) {
      for (const keyword of segmentMention.keywords) {
        for (const clientId of segmentMention.clients) {
          const key = `${workspaceId}::${keyword}::${clientId}`;
          if (!uniqueMap.has(key)) {
            uniqueMap.set(key, {
              workspaceId,
              keyword,
              clientId,
              queryId: segmentMention.query_id,
            });
          }
        }
      }
    }
  }

  return [...uniqueMap.values()];
}
